import { createContext, useState, useEffect, useContext } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    // Read from localStorage or default to 'default'
    const [theme, setTheme] = useState(() => {
        return localStorage.getItem('app-theme') || 'default';
    });

    useEffect(() => {
        // Apply theme to document body
        document.body.setAttribute('data-theme', theme);
        // Persist to localStorage
        localStorage.setItem('app-theme', theme);
    }, [theme]);

    return (
        <ThemeContext.Provider value={{ theme, setTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);
